// source: compliancesetting/compliancesetting.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var google_api_annotations_pb = require('../google/api/annotations_pb.js');
goog.object.extend(proto, google_api_annotations_pb);
var google_api_client_pb = require('../google/api/client_pb.js');
goog.object.extend(proto, google_api_client_pb);
var google_api_field_behavior_pb = require('../google/api/field_behavior_pb.js');
goog.object.extend(proto, google_api_field_behavior_pb);
var google_api_resource_pb = require('../google/api/resource_pb.js');
goog.object.extend(proto, google_api_resource_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var common_historyinformation_pb = require('../common/historyinformation_pb.js');
goog.object.extend(proto, common_historyinformation_pb);
var common_fieldchangelog_pb = require('../common/fieldchangelog_pb.js');
goog.object.extend(proto, common_fieldchangelog_pb);
goog.exportSymbol('proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting', null, global);
goog.exportSymbol('proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingChangeLog', null, global);
goog.exportSymbol('proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory', null, global);
goog.exportSymbol('proto.verily.sdp.compliancesetting.v1alpha1.CreateComplianceSettingRequest', null, global);
goog.exportSymbol('proto.verily.sdp.compliancesetting.v1alpha1.GetComplianceSettingRequest', null, global);
goog.exportSymbol('proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingChangeLogsRequest', null, global);
goog.exportSymbol('proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingChangeLogsResponse', null, global);
goog.exportSymbol('proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingHistoriesRequest', null, global);
goog.exportSymbol('proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingHistoriesResponse', null, global);
goog.exportSymbol('proto.verily.sdp.compliancesetting.v1alpha1.UpdateComplianceSettingRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting.displayName = 'proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.verily.sdp.compliancesetting.v1alpha1.CreateComplianceSettingRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.verily.sdp.compliancesetting.v1alpha1.CreateComplianceSettingRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.verily.sdp.compliancesetting.v1alpha1.CreateComplianceSettingRequest.displayName = 'proto.verily.sdp.compliancesetting.v1alpha1.CreateComplianceSettingRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.verily.sdp.compliancesetting.v1alpha1.UpdateComplianceSettingRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.verily.sdp.compliancesetting.v1alpha1.UpdateComplianceSettingRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.verily.sdp.compliancesetting.v1alpha1.UpdateComplianceSettingRequest.displayName = 'proto.verily.sdp.compliancesetting.v1alpha1.UpdateComplianceSettingRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.verily.sdp.compliancesetting.v1alpha1.GetComplianceSettingRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.verily.sdp.compliancesetting.v1alpha1.GetComplianceSettingRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.verily.sdp.compliancesetting.v1alpha1.GetComplianceSettingRequest.displayName = 'proto.verily.sdp.compliancesetting.v1alpha1.GetComplianceSettingRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory.displayName = 'proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingChangeLog = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingChangeLog.repeatedFields_, null);
};
goog.inherits(proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingChangeLog, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingChangeLog.displayName = 'proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingChangeLog';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingHistoriesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingHistoriesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingHistoriesRequest.displayName = 'proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingHistoriesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingChangeLogsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingChangeLogsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingChangeLogsRequest.displayName = 'proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingChangeLogsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingHistoriesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingHistoriesResponse.repeatedFields_, null);
};
goog.inherits(proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingHistoriesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingHistoriesResponse.displayName = 'proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingHistoriesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingChangeLogsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingChangeLogsResponse.repeatedFields_, null);
};
goog.inherits(proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingChangeLogsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingChangeLogsResponse.displayName = 'proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingChangeLogsResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting.prototype.toObject = function(opt_includeInstance) {
  return proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    wearTimeDaysPerWeek: jspb.Message.getFieldWithDefault(msg, 2, 0),
    wearTimeHoursPerDay: jspb.Message.getFieldWithDefault(msg, 3, 0),
    syncDaysPerWeek: jspb.Message.getFieldWithDefault(msg, 4, 0),
    surveySubmissionPercentage: jspb.Message.getFieldWithDefault(msg, 5, 0),
    medsLoggedPerDay: jspb.Message.getFieldWithDefault(msg, 6, 0),
    medsLoggedPerWeek: jspb.Message.getFieldWithDefault(msg, 7, 0),
    updatedTime: (f = msg.getUpdatedTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    ecgReadingsPerDay: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting;
  return proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWearTimeDaysPerWeek(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWearTimeHoursPerDay(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSyncDaysPerWeek(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSurveySubmissionPercentage(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMedsLoggedPerDay(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMedsLoggedPerWeek(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedTime(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEcgReadingsPerDay(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getWearTimeDaysPerWeek();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getWearTimeHoursPerDay();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getSyncDaysPerWeek();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getSurveySubmissionPercentage();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getMedsLoggedPerDay();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getMedsLoggedPerWeek();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getUpdatedTime();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEcgReadingsPerDay();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting} returns this
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 wear_time_days_per_week = 2;
 * @return {number}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting.prototype.getWearTimeDaysPerWeek = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting} returns this
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting.prototype.setWearTimeDaysPerWeek = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 wear_time_hours_per_day = 3;
 * @return {number}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting.prototype.getWearTimeHoursPerDay = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting} returns this
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting.prototype.setWearTimeHoursPerDay = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 sync_days_per_week = 4;
 * @return {number}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting.prototype.getSyncDaysPerWeek = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting} returns this
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting.prototype.setSyncDaysPerWeek = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 survey_submission_percentage = 5;
 * @return {number}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting.prototype.getSurveySubmissionPercentage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting} returns this
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting.prototype.setSurveySubmissionPercentage = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 meds_logged_per_day = 6;
 * @return {number}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting.prototype.getMedsLoggedPerDay = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting} returns this
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting.prototype.setMedsLoggedPerDay = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 meds_logged_per_week = 7;
 * @return {number}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting.prototype.getMedsLoggedPerWeek = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting} returns this
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting.prototype.setMedsLoggedPerWeek = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional google.protobuf.Timestamp updated_time = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting.prototype.getUpdatedTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting} returns this
*/
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting.prototype.setUpdatedTime = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting} returns this
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting.prototype.clearUpdatedTime = function() {
  return this.setUpdatedTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting.prototype.hasUpdatedTime = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional int32 ecg_readings_per_day = 9;
 * @return {number}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting.prototype.getEcgReadingsPerDay = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting} returns this
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting.prototype.setEcgReadingsPerDay = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.verily.sdp.compliancesetting.v1alpha1.CreateComplianceSettingRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.verily.sdp.compliancesetting.v1alpha1.CreateComplianceSettingRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.verily.sdp.compliancesetting.v1alpha1.CreateComplianceSettingRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.verily.sdp.compliancesetting.v1alpha1.CreateComplianceSettingRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    complianceSetting: (f = msg.getComplianceSetting()) && proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.CreateComplianceSettingRequest}
 */
proto.verily.sdp.compliancesetting.v1alpha1.CreateComplianceSettingRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.verily.sdp.compliancesetting.v1alpha1.CreateComplianceSettingRequest;
  return proto.verily.sdp.compliancesetting.v1alpha1.CreateComplianceSettingRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.verily.sdp.compliancesetting.v1alpha1.CreateComplianceSettingRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.CreateComplianceSettingRequest}
 */
proto.verily.sdp.compliancesetting.v1alpha1.CreateComplianceSettingRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting;
      reader.readMessage(value,proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting.deserializeBinaryFromReader);
      msg.setComplianceSetting(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.verily.sdp.compliancesetting.v1alpha1.CreateComplianceSettingRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.verily.sdp.compliancesetting.v1alpha1.CreateComplianceSettingRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.verily.sdp.compliancesetting.v1alpha1.CreateComplianceSettingRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.verily.sdp.compliancesetting.v1alpha1.CreateComplianceSettingRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getComplianceSetting();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting.serializeBinaryToWriter
    );
  }
};


/**
 * optional ComplianceSetting compliance_setting = 1;
 * @return {?proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting}
 */
proto.verily.sdp.compliancesetting.v1alpha1.CreateComplianceSettingRequest.prototype.getComplianceSetting = function() {
  return /** @type{?proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting} */ (
    jspb.Message.getWrapperField(this, proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting, 1));
};


/**
 * @param {?proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting|undefined} value
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.CreateComplianceSettingRequest} returns this
*/
proto.verily.sdp.compliancesetting.v1alpha1.CreateComplianceSettingRequest.prototype.setComplianceSetting = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.CreateComplianceSettingRequest} returns this
 */
proto.verily.sdp.compliancesetting.v1alpha1.CreateComplianceSettingRequest.prototype.clearComplianceSetting = function() {
  return this.setComplianceSetting(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.verily.sdp.compliancesetting.v1alpha1.CreateComplianceSettingRequest.prototype.hasComplianceSetting = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.verily.sdp.compliancesetting.v1alpha1.UpdateComplianceSettingRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.verily.sdp.compliancesetting.v1alpha1.UpdateComplianceSettingRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.verily.sdp.compliancesetting.v1alpha1.UpdateComplianceSettingRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.verily.sdp.compliancesetting.v1alpha1.UpdateComplianceSettingRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    complianceSetting: (f = msg.getComplianceSetting()) && proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting.toObject(includeInstance, f),
    updateReason: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.UpdateComplianceSettingRequest}
 */
proto.verily.sdp.compliancesetting.v1alpha1.UpdateComplianceSettingRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.verily.sdp.compliancesetting.v1alpha1.UpdateComplianceSettingRequest;
  return proto.verily.sdp.compliancesetting.v1alpha1.UpdateComplianceSettingRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.verily.sdp.compliancesetting.v1alpha1.UpdateComplianceSettingRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.UpdateComplianceSettingRequest}
 */
proto.verily.sdp.compliancesetting.v1alpha1.UpdateComplianceSettingRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting;
      reader.readMessage(value,proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting.deserializeBinaryFromReader);
      msg.setComplianceSetting(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdateReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.verily.sdp.compliancesetting.v1alpha1.UpdateComplianceSettingRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.verily.sdp.compliancesetting.v1alpha1.UpdateComplianceSettingRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.verily.sdp.compliancesetting.v1alpha1.UpdateComplianceSettingRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.verily.sdp.compliancesetting.v1alpha1.UpdateComplianceSettingRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getComplianceSetting();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting.serializeBinaryToWriter
    );
  }
  f = message.getUpdateReason();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional ComplianceSetting compliance_setting = 1;
 * @return {?proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting}
 */
proto.verily.sdp.compliancesetting.v1alpha1.UpdateComplianceSettingRequest.prototype.getComplianceSetting = function() {
  return /** @type{?proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting} */ (
    jspb.Message.getWrapperField(this, proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting, 1));
};


/**
 * @param {?proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting|undefined} value
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.UpdateComplianceSettingRequest} returns this
*/
proto.verily.sdp.compliancesetting.v1alpha1.UpdateComplianceSettingRequest.prototype.setComplianceSetting = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.UpdateComplianceSettingRequest} returns this
 */
proto.verily.sdp.compliancesetting.v1alpha1.UpdateComplianceSettingRequest.prototype.clearComplianceSetting = function() {
  return this.setComplianceSetting(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.verily.sdp.compliancesetting.v1alpha1.UpdateComplianceSettingRequest.prototype.hasComplianceSetting = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string update_reason = 2;
 * @return {string}
 */
proto.verily.sdp.compliancesetting.v1alpha1.UpdateComplianceSettingRequest.prototype.getUpdateReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.UpdateComplianceSettingRequest} returns this
 */
proto.verily.sdp.compliancesetting.v1alpha1.UpdateComplianceSettingRequest.prototype.setUpdateReason = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.verily.sdp.compliancesetting.v1alpha1.GetComplianceSettingRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.verily.sdp.compliancesetting.v1alpha1.GetComplianceSettingRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.verily.sdp.compliancesetting.v1alpha1.GetComplianceSettingRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.verily.sdp.compliancesetting.v1alpha1.GetComplianceSettingRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.GetComplianceSettingRequest}
 */
proto.verily.sdp.compliancesetting.v1alpha1.GetComplianceSettingRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.verily.sdp.compliancesetting.v1alpha1.GetComplianceSettingRequest;
  return proto.verily.sdp.compliancesetting.v1alpha1.GetComplianceSettingRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.verily.sdp.compliancesetting.v1alpha1.GetComplianceSettingRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.GetComplianceSettingRequest}
 */
proto.verily.sdp.compliancesetting.v1alpha1.GetComplianceSettingRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.verily.sdp.compliancesetting.v1alpha1.GetComplianceSettingRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.verily.sdp.compliancesetting.v1alpha1.GetComplianceSettingRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.verily.sdp.compliancesetting.v1alpha1.GetComplianceSettingRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.verily.sdp.compliancesetting.v1alpha1.GetComplianceSettingRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.verily.sdp.compliancesetting.v1alpha1.GetComplianceSettingRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.GetComplianceSettingRequest} returns this
 */
proto.verily.sdp.compliancesetting.v1alpha1.GetComplianceSettingRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory.prototype.toObject = function(opt_includeInstance) {
  return proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    wearTimeDaysPerWeek: jspb.Message.getFieldWithDefault(msg, 2, 0),
    wearTimeHoursPerDay: jspb.Message.getFieldWithDefault(msg, 3, 0),
    syncDaysPerWeek: jspb.Message.getFieldWithDefault(msg, 4, 0),
    surveySubmissionPercentage: jspb.Message.getFieldWithDefault(msg, 5, 0),
    medsLoggedPerDay: jspb.Message.getFieldWithDefault(msg, 6, 0),
    medsLoggedPerWeek: jspb.Message.getFieldWithDefault(msg, 7, 0),
    ecgReadingsPerDay: jspb.Message.getFieldWithDefault(msg, 15, 0),
    updatedTime: (f = msg.getUpdatedTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    version: jspb.Message.getFieldWithDefault(msg, 9, 0),
    operation: jspb.Message.getFieldWithDefault(msg, 10, ""),
    updateReason: jspb.Message.getFieldWithDefault(msg, 11, ""),
    actorName: jspb.Message.getFieldWithDefault(msg, 12, ""),
    actorEmail: jspb.Message.getFieldWithDefault(msg, 13, ""),
    actorRole: jspb.Message.getFieldWithDefault(msg, 14, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory;
  return proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWearTimeDaysPerWeek(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWearTimeHoursPerDay(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSyncDaysPerWeek(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSurveySubmissionPercentage(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMedsLoggedPerDay(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMedsLoggedPerWeek(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEcgReadingsPerDay(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedTime(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVersion(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setOperation(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdateReason(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setActorName(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setActorEmail(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setActorRole(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getWearTimeDaysPerWeek();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getWearTimeHoursPerDay();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getSyncDaysPerWeek();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getSurveySubmissionPercentage();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getMedsLoggedPerDay();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getMedsLoggedPerWeek();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getEcgReadingsPerDay();
  if (f !== 0) {
    writer.writeInt32(
      15,
      f
    );
  }
  f = message.getUpdatedTime();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getVersion();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getOperation();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getUpdateReason();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getActorName();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getActorEmail();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getActorRole();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory} returns this
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 wear_time_days_per_week = 2;
 * @return {number}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory.prototype.getWearTimeDaysPerWeek = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory} returns this
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory.prototype.setWearTimeDaysPerWeek = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 wear_time_hours_per_day = 3;
 * @return {number}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory.prototype.getWearTimeHoursPerDay = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory} returns this
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory.prototype.setWearTimeHoursPerDay = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 sync_days_per_week = 4;
 * @return {number}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory.prototype.getSyncDaysPerWeek = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory} returns this
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory.prototype.setSyncDaysPerWeek = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 survey_submission_percentage = 5;
 * @return {number}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory.prototype.getSurveySubmissionPercentage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory} returns this
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory.prototype.setSurveySubmissionPercentage = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 meds_logged_per_day = 6;
 * @return {number}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory.prototype.getMedsLoggedPerDay = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory} returns this
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory.prototype.setMedsLoggedPerDay = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 meds_logged_per_week = 7;
 * @return {number}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory.prototype.getMedsLoggedPerWeek = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory} returns this
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory.prototype.setMedsLoggedPerWeek = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 ecg_readings_per_day = 15;
 * @return {number}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory.prototype.getEcgReadingsPerDay = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory} returns this
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory.prototype.setEcgReadingsPerDay = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional google.protobuf.Timestamp updated_time = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory.prototype.getUpdatedTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory} returns this
*/
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory.prototype.setUpdatedTime = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory} returns this
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory.prototype.clearUpdatedTime = function() {
  return this.setUpdatedTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory.prototype.hasUpdatedTime = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional int32 version = 9;
 * @return {number}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory} returns this
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory.prototype.setVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional string operation = 10;
 * @return {string}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory.prototype.getOperation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory} returns this
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory.prototype.setOperation = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string update_reason = 11;
 * @return {string}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory.prototype.getUpdateReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory} returns this
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory.prototype.setUpdateReason = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string actor_name = 12;
 * @return {string}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory.prototype.getActorName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory} returns this
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory.prototype.setActorName = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string actor_email = 13;
 * @return {string}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory.prototype.getActorEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory} returns this
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory.prototype.setActorEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string actor_role = 14;
 * @return {string}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory.prototype.getActorRole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory} returns this
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory.prototype.setActorRole = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingChangeLog.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingChangeLog.prototype.toObject = function(opt_includeInstance) {
  return proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingChangeLog.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingChangeLog} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingChangeLog.toObject = function(includeInstance, msg) {
  var f, obj = {
    complianceSetting: (f = msg.getComplianceSetting()) && proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting.toObject(includeInstance, f),
    fieldChangeLogsList: jspb.Message.toObjectList(msg.getFieldChangeLogsList(),
    common_fieldchangelog_pb.FieldChangeLog.toObject, includeInstance),
    historyInformation: (f = msg.getHistoryInformation()) && common_historyinformation_pb.HistoryInformation.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingChangeLog}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingChangeLog.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingChangeLog;
  return proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingChangeLog.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingChangeLog} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingChangeLog}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingChangeLog.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting;
      reader.readMessage(value,proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting.deserializeBinaryFromReader);
      msg.setComplianceSetting(value);
      break;
    case 2:
      var value = new common_fieldchangelog_pb.FieldChangeLog;
      reader.readMessage(value,common_fieldchangelog_pb.FieldChangeLog.deserializeBinaryFromReader);
      msg.addFieldChangeLogs(value);
      break;
    case 3:
      var value = new common_historyinformation_pb.HistoryInformation;
      reader.readMessage(value,common_historyinformation_pb.HistoryInformation.deserializeBinaryFromReader);
      msg.setHistoryInformation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingChangeLog.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingChangeLog.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingChangeLog} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingChangeLog.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getComplianceSetting();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting.serializeBinaryToWriter
    );
  }
  f = message.getFieldChangeLogsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      common_fieldchangelog_pb.FieldChangeLog.serializeBinaryToWriter
    );
  }
  f = message.getHistoryInformation();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      common_historyinformation_pb.HistoryInformation.serializeBinaryToWriter
    );
  }
};


/**
 * optional ComplianceSetting compliance_setting = 1;
 * @return {?proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingChangeLog.prototype.getComplianceSetting = function() {
  return /** @type{?proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting} */ (
    jspb.Message.getWrapperField(this, proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting, 1));
};


/**
 * @param {?proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSetting|undefined} value
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingChangeLog} returns this
*/
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingChangeLog.prototype.setComplianceSetting = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingChangeLog} returns this
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingChangeLog.prototype.clearComplianceSetting = function() {
  return this.setComplianceSetting(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingChangeLog.prototype.hasComplianceSetting = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated verily.sdp.common.v1alpha1.FieldChangeLog field_change_logs = 2;
 * @return {!Array<!proto.verily.sdp.common.v1alpha1.FieldChangeLog>}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingChangeLog.prototype.getFieldChangeLogsList = function() {
  return /** @type{!Array<!proto.verily.sdp.common.v1alpha1.FieldChangeLog>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_fieldchangelog_pb.FieldChangeLog, 2));
};


/**
 * @param {!Array<!proto.verily.sdp.common.v1alpha1.FieldChangeLog>} value
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingChangeLog} returns this
*/
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingChangeLog.prototype.setFieldChangeLogsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.verily.sdp.common.v1alpha1.FieldChangeLog=} opt_value
 * @param {number=} opt_index
 * @return {!proto.verily.sdp.common.v1alpha1.FieldChangeLog}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingChangeLog.prototype.addFieldChangeLogs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.verily.sdp.common.v1alpha1.FieldChangeLog, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingChangeLog} returns this
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingChangeLog.prototype.clearFieldChangeLogsList = function() {
  return this.setFieldChangeLogsList([]);
};


/**
 * optional verily.sdp.common.v1alpha1.HistoryInformation history_information = 3;
 * @return {?proto.verily.sdp.common.v1alpha1.HistoryInformation}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingChangeLog.prototype.getHistoryInformation = function() {
  return /** @type{?proto.verily.sdp.common.v1alpha1.HistoryInformation} */ (
    jspb.Message.getWrapperField(this, common_historyinformation_pb.HistoryInformation, 3));
};


/**
 * @param {?proto.verily.sdp.common.v1alpha1.HistoryInformation|undefined} value
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingChangeLog} returns this
*/
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingChangeLog.prototype.setHistoryInformation = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingChangeLog} returns this
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingChangeLog.prototype.clearHistoryInformation = function() {
  return this.setHistoryInformation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingChangeLog.prototype.hasHistoryInformation = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingHistoriesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingHistoriesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingHistoriesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingHistoriesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    registryId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingHistoriesRequest}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingHistoriesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingHistoriesRequest;
  return proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingHistoriesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingHistoriesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingHistoriesRequest}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingHistoriesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegistryId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingHistoriesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingHistoriesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingHistoriesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingHistoriesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRegistryId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string registry_id = 1;
 * @return {string}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingHistoriesRequest.prototype.getRegistryId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingHistoriesRequest} returns this
 */
proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingHistoriesRequest.prototype.setRegistryId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingChangeLogsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingChangeLogsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingChangeLogsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingChangeLogsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    registryId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingChangeLogsRequest}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingChangeLogsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingChangeLogsRequest;
  return proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingChangeLogsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingChangeLogsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingChangeLogsRequest}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingChangeLogsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegistryId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingChangeLogsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingChangeLogsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingChangeLogsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingChangeLogsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRegistryId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string registry_id = 1;
 * @return {string}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingChangeLogsRequest.prototype.getRegistryId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingChangeLogsRequest} returns this
 */
proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingChangeLogsRequest.prototype.setRegistryId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingHistoriesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingHistoriesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingHistoriesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingHistoriesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingHistoriesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    complianceSettingHistoriesList: jspb.Message.toObjectList(msg.getComplianceSettingHistoriesList(),
    proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingHistoriesResponse}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingHistoriesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingHistoriesResponse;
  return proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingHistoriesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingHistoriesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingHistoriesResponse}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingHistoriesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory;
      reader.readMessage(value,proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory.deserializeBinaryFromReader);
      msg.addComplianceSettingHistories(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingHistoriesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingHistoriesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingHistoriesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingHistoriesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getComplianceSettingHistoriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ComplianceSettingHistory compliance_setting_histories = 1;
 * @return {!Array<!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory>}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingHistoriesResponse.prototype.getComplianceSettingHistoriesList = function() {
  return /** @type{!Array<!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory, 1));
};


/**
 * @param {!Array<!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory>} value
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingHistoriesResponse} returns this
*/
proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingHistoriesResponse.prototype.setComplianceSettingHistoriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory=} opt_value
 * @param {number=} opt_index
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingHistoriesResponse.prototype.addComplianceSettingHistories = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingHistory, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingHistoriesResponse} returns this
 */
proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingHistoriesResponse.prototype.clearComplianceSettingHistoriesList = function() {
  return this.setComplianceSettingHistoriesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingChangeLogsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingChangeLogsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingChangeLogsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingChangeLogsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingChangeLogsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    complianceSettingHistoriesChangeLogsList: jspb.Message.toObjectList(msg.getComplianceSettingHistoriesChangeLogsList(),
    proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingChangeLog.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingChangeLogsResponse}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingChangeLogsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingChangeLogsResponse;
  return proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingChangeLogsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingChangeLogsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingChangeLogsResponse}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingChangeLogsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingChangeLog;
      reader.readMessage(value,proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingChangeLog.deserializeBinaryFromReader);
      msg.addComplianceSettingHistoriesChangeLogs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingChangeLogsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingChangeLogsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingChangeLogsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingChangeLogsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getComplianceSettingHistoriesChangeLogsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingChangeLog.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ComplianceSettingChangeLog compliance_setting_histories_change_logs = 1;
 * @return {!Array<!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingChangeLog>}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingChangeLogsResponse.prototype.getComplianceSettingHistoriesChangeLogsList = function() {
  return /** @type{!Array<!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingChangeLog>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingChangeLog, 1));
};


/**
 * @param {!Array<!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingChangeLog>} value
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingChangeLogsResponse} returns this
*/
proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingChangeLogsResponse.prototype.setComplianceSettingHistoriesChangeLogsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingChangeLog=} opt_value
 * @param {number=} opt_index
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingChangeLog}
 */
proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingChangeLogsResponse.prototype.addComplianceSettingHistoriesChangeLogs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.verily.sdp.compliancesetting.v1alpha1.ComplianceSettingChangeLog, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingChangeLogsResponse} returns this
 */
proto.verily.sdp.compliancesetting.v1alpha1.ListComplianceSettingChangeLogsResponse.prototype.clearComplianceSettingHistoriesChangeLogsList = function() {
  return this.setComplianceSettingHistoriesChangeLogsList([]);
};


goog.object.extend(exports, proto.verily.sdp.compliancesetting.v1alpha1);
